import React, { useState, useRef } from 'react';
import Button from '../../TableButton';
import { useI18n, useClickOutside, usePrintBill } from '~Hooks';
import SwapIcon from '~/Assets/icons/receipt_long.svg';
import { Wrapper, ListWapper, List } from './styles';

interface Props {
  selectedCheque: string;
  selectedTable: { id: string; name: string } | null;
  staffId: any;
  showLogin: () => void;
}

const PrintBillCompo = ({ selectedCheque, selectedTable, showLogin, staffId }: Props) => {
  const { i18n } = useI18n();
  const { printBill, printInvoiceBill } = usePrintBill({ selectedCheque, selectedTable });

  const [isOpen, setIsOpen] = useState(false);
  const openList = () => setIsOpen(true);
  const closeList = () => setIsOpen(false);

  const ref = useRef<any>();
  useClickOutside(ref, () => closeList());

  const showIcon = window.innerWidth > 800;

  const [touching, setTouching] = useState(false);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const handlePrintBill = () => {
    if (!staffId) showLogin();

    printBill();
    closeList();
  };

  const handlePrintInvoiceBill = () => {
    if (!staffId) showLogin();

    printInvoiceBill();
    closeList();
  };

  const handleTouchStart = () => {
    setTouching(true);

    /* On long touch */
    timeoutRef.current = setTimeout(() => {
      openList();
      setTouching(false);
    }, 500);
  };

  const handleTouchEnd = () => {
    /* On touch */
    if (touching) handlePrintBill();

    setTouching(false);
    clearTimeout(timeoutRef.current!);
  };

  return (
    <Wrapper ref={ref}>
      {isOpen && (
        <ListWapper>
          <List>
            <Button onTouchStart={handlePrintBill}>{i18n('TM.Bill')}</Button>
            <Button onTouchStart={handlePrintInvoiceBill}>{i18n('TM.InvoiceBill')}</Button>
          </List>
          <Button onTouchStart={closeList} color="#e3273b">
            {i18n('TM.Close')}
          </Button>
        </ListWapper>
      )}
      <Button
        icon={showIcon && SwapIcon}
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}>
        {i18n('TM.Bill')}
      </Button>
    </Wrapper>
  );
};

export const PrintBill = React.memo(PrintBillCompo);
